export default {
  /**
   * 获取url上的所有参数
   * @param uri
   * @returns
   */
  getAllParams: (str: string) => {
    // 定义返回结果
    const result: { [key: string]: any } = {};
    const url = str.replace(/#\//g, '').split('?')[1];
    if (!url) return {};
    const urlArr = url.split('&'); // 以&符号分割为数组
    for (let i = 0; i < urlArr.length; i++) {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const _urlArr = urlArr[i].split('='); // 以"="分割为数组
      result[_urlArr[0]] = _urlArr[1];
    }
    return result;
  },
  /**
   * 解析二维码scene参数，eg：type_id_productId
   * @param str
   */
  parseQueryScene: (str: string) => {
    if (!str) {
      console.log(`<解析二维码scene参数错误>`, str);
      return null;
    }
    const params = str.split('_');
    return {
      type: params[0],
      id: params[1],
      productId: params[2],
      distributionId: params[3],
    };
  },
};
